<template>
  <div>
    <v-dialog
      :value="dialog"
      fullscreen
      persistent
      scrollable
    >
      <v-card v-if="stype === 'table'">
        <AdCardTitle>
          {{ $t('simplified-spreadsheet') }}
        </AdCardTitle>

        <v-card-text>
          <TreeTable
            ref="treeTable"
            class="tree-table"
            :fixedHeader="true"
            :headers="headers"
            :items="representingTemplate"
            item-key="navkey"
            item-children="concept"
          >
            <template v-slot:[`item.name`]="{ item }">
              <v-icon class="pr-2" :color="$filters.getStatusColor(item.statusCode)">
                {{ $filters.getDatasetIcon(item) }}
              </v-icon>
              <span :class="item.absent ? 'grey-text' : 'font-weight-bold'">
                {{ $filters.getMatchingTranslation({ value: item.name }) }}
                <div class="ml-9 mb-2 font-weight-light">
                  {{ $filters.getMatchingTranslation({ value: item.desc }) }}
                </div>
              </span>
            </template>

            <template v-slot:[`item.card`]="{ item }">
              {{ [item.minimumMultiplicity, '..', item.maximumMultiplicity].join('') }}
            </template>

            <template v-slot:[`item.id`]="{ item }">
              <AdShortId :id="item.id" pill :color="$filters.getStatusColor(item.statusCode)"/>
            </template>

          </TreeTable>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <AdButton
            type="close"
            @click="closeDialog"
          />
        </v-card-actions>
      </v-card>
      <v-card v-if="stype === 'graph'">
        <AdCardTitle>
            {{ $t('simplified-graph') }}
        </AdCardTitle>
        <v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <AdButton
            type="close"
            @click="closeDialog"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    stype: {
      type: String,
      default: 'table'
    },
    representingTemplate: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
          width: '30%'
        },
        {
          text: this.$t('card'),
          value: 'card',
          width: '10%'
        },
        {
          text: this.$t('conf'),
          value: 'conformance',
          width: '10%'
        },
        {
          text: this.$t('id'),
          value: 'id',
          width: '5%'
        },
        {
          value: 'actions',
          text: '',
          width: '10%'
        }
      ]
    }
  },

  methods: {
    closeDialog () {
      this.$emit('close')
    }

  }
}
</script>

<style lang="scss">

.tree-table {
  .tree-table-toggle {
    .tree-table-toggle-content {
      align-items: flex-start;

      .tree-table-toggle-content-levels {
        align-items: flex-start;

        .tree-table-toggle-button {
          margin-top: 11px;
        }
      }

      .tree-table-toggle-content-value {
        margin-top: 11px;
      }
    }
  }
}

</style>
